import { Button } from '@heroui/react';
import classNames from 'classnames';
import type { TFuncKey } from 'i18next';
import type { ReactNode } from 'react';
import { useDebouncedLoader } from 'use-debounced-loader';

import {
  optionButtonClass,
  optionButtonProps,
  optionLabelClass,
} from '@/components/Button/option-button-class';
import DynamicT from '@/shared/components/DynamicT';
import MatrixLoader from '@/shared/components/MatrixLoader';

type Props = {
  readonly className?: string;
  readonly icon: ReactNode;
  readonly text: TFuncKey;
  readonly isLoading?: boolean;
  readonly onClick: () => void;
};

/** Styled like the first screen's alternative sign-in rows, so a method switch reads as one. */
const MethodSwitchButton = ({ className, icon, text, isLoading = false, onClick }: Props) => {
  const isLoadingActive = useDebouncedLoader(isLoading, 300);

  return (
    <Button
      {...optionButtonProps}
      className={classNames(optionButtonClass, '[&>svg]:size-5 [&>svg]:shrink-0', className)}
      isPending={isLoadingActive}
      onPress={onClick}
    >
      {icon}
      <span className={optionLabelClass}>
        <DynamicT forKey={text} />
      </span>
      {isLoadingActive && (
        <span className="absolute inset-y-0 inset-e-4 flex items-center animate-in fade-in duration-(--duration-quick)">
          <MatrixLoader size="sm" />
        </span>
      )}
    </Button>
  );
};

export default MethodSwitchButton;
